module.exports = __webpack_public_path__ + "media/src/images/about/outline/extention-935e4dc1db1d3e7910070851cbdfb2fd.png";